import { create } from "zustand";
import type { MerchantAliasListItem } from "@boo/shared";
import {
  getMerchantAliasesList,
  upsertAlias as apiUpsertAlias,
} from "@/services/merchantAliasApi";

interface MerchantAliasState {
  items: MerchantAliasListItem[];
  page: number;
  pageSize: number;
  total: number;
  loading: boolean;
  fetchAliases: (page?: number) => Promise<void>;
  upsertAlias: (rawName: string, alias: string) => Promise<void>;
}

export const useMerchantAliasStore = create<MerchantAliasState>((set, get) => ({
  items: [],
  page: 1,
  pageSize: 20,
  total: 0,
  loading: false,

  async fetchAliases(page = 1) {
    const { pageSize } = get();
    set({ loading: true });
    try {
      const res = await getMerchantAliasesList(page, pageSize);
      set({ items: res.items, page: res.page, total: res.total });
    } finally {
      set({ loading: false });
    }
  },

  async upsertAlias(rawName, alias) {
    const res = await apiUpsertAlias(rawName, alias);
    const { items, page } = get();
    const idx = items.findIndex((i) => i.rawName === rawName);
    if (idx !== -1) {
      const updated = [...items];
      updated[idx] = {
        ...updated[idx],
        alias: res.alias,
        matchedCount: res.matchedCount,
        updatedAt: new Date().toISOString(),
      };
      set({ items: updated });
    } else {
      get().fetchAliases(page);
    }
  },
}));
